const configRoutes = [
  {
    path: '/config',
    name: 'Config',
    component: () => import('../views/Config/Config.vue')
  }
]

export default configRoutes
